import { Modal } from "@mui/material"
import CloseIcon from "@mui/icons-material/Close";
import { IOperacaoAgricola } from "../../Interfaces/atividade/atividade";
import { IPlanoERPSchema } from "../../Interfaces/financeiro/financeiro";
import { useState } from "react";

interface I_aux {
    flag_open_modal: boolean,
    set_flag_open_modal: React.Dispatch<React.SetStateAction<boolean>>,
    flag_open_modal_ver_mais: boolean,
    set_flag_open_modal_ver_mais: React.Dispatch<React.SetStateAction<boolean>>,
    obj_new: IOperacaoAgricola | undefined,
    lista_financeiro: IPlanoERPSchema[],
}

export const Modalveratividade: React.FC<I_aux> = ({
    flag_open_modal,
    set_flag_open_modal,
    flag_open_modal_ver_mais,
    set_flag_open_modal_ver_mais,
    obj_new,
    lista_financeiro,

}) => {

    const planoSelecionado = lista_financeiro.find(
        (el) => el.id_plano === obj_new?.id_plano
    );

    return (<Modal
        style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        }}
        open={flag_open_modal}
    >
        <div className="flex flex-col bg-white w-[70%] max-h-[80%] rounded-xl overflow-hidden">
            <div className="flex items-center justify-between w-full p-4 border-b border-gray-100">
                <h2 className="text-xl font-semibold text-gray-800 m-0 pl-2">
                    Detalhes da Atividade

                </h2>
                <button
                    type="button"
                    onClick={() => {
                        set_flag_open_modal(false)
                        set_flag_open_modal_ver_mais(false)
                    }}
                    className="p-1 text-gray-400 hover:text-gray-600 transition-colors border-0 outline-none cursor-pointer !bg-transparent hover:!bg-transparent"
                >
                    <CloseIcon sx={{ fontSize: 24 }} />
                </button>
            </div>



            <div className="flex flex-col items-center w-full flex-1 overflow-auto">
                <div className="flex flex-col w-full p-6 gap-6">

                    {/* Plano associado */}
                    <div className="w-full">
                        <div className="mb-3 text-xs font-semibold uppercase tracking-wider text-gray-400">
                            Plano Associado
                        </div>

                        <div className="w-full sm:w-fit min-w-[220px] max-w-[320px] rounded-xl border border-[#c94f1e] bg-[#f2d1c2]/20 px-4 py-4 shadow-sm">
                            <div className="text-sm font-medium text-gray-800 break-words">
                                {planoSelecionado?.nome || '-'}
                            </div>
                            <div className="mt-3 w-full h-1 rounded-full bg-[#c94f1e]" />
                        </div>
                    </div>

                    {/* Detalhes */}
                    <div className="flex flex-col w-full gap-5">
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-x-6 gap-y-5 w-full items-start">
                            <div className="w-full">
                                <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">
                                    Fase Produção
                                </div>
                                <div className="text-base font-medium text-gray-800 break-words">
                                    {obj_new?.fase_producao || '-'}
                                </div>
                            </div>

                            <div className="w-full">
                                <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">
                                    Tipo de Operação
                                </div>
                                <div className="text-base font-medium text-gray-800 break-words">
                                    {obj_new?.tipo_operacao || '-'}
                                </div>
                            </div>

                            <div className="w-full">
                                <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">
                                    Descrição
                                </div>
                                <div className="text-base font-medium text-gray-800 break-words">
                                    {obj_new?.descricao || '-'}
                                </div>
                            </div>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-3 gap-x-6 gap-y-5 w-full items-start">
                            <div className="w-full">
                                <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">
                                    Data Início
                                </div>
                                <div className="text-base font-medium text-gray-800">
                                    {obj_new?.data_inicio
                                        ? new Date(obj_new.data_inicio).toLocaleDateString()
                                        : '-'}
                                </div>
                            </div>

                            <div className="w-full">
                                <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">
                                    Data Fim
                                </div>
                                <div className="text-base font-medium text-gray-800">
                                    {obj_new?.data_fim
                                        ? new Date(obj_new.data_fim).toLocaleDateString()
                                        : '-'}
                                </div>
                            </div>

                            <div className="w-full">
                                <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">
                                    Estado
                                </div>
                                <div className="text-base font-medium text-gray-800">
                                    {obj_new?.estado || '-'}
                                </div>
                            </div>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-3 gap-x-6 gap-y-5 w-full items-start">
                            <div className="w-full">
                                <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">
                                    Prioridade
                                </div>
                                <div className="text-base font-medium text-gray-800">
                                    {obj_new?.prioridade || '-'}
                                </div>
                            </div>

                            <div className="w-full">
                                <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">
                                    Custo Estimado
                                </div>
                                <div className="text-base font-medium text-gray-800">
                                    {obj_new?.custo_estimado !== undefined && obj_new?.custo_estimado !== null
                                        ? `€ ${obj_new.custo_estimado.toFixed(2)}`
                                        : '-'}
                                </div>
                            </div>

                            <div className="w-full">
                                <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">
                                    Custo Real
                                </div>
                                <div className="text-base font-medium text-gray-800">
                                    {obj_new?.custo_real !== undefined && obj_new?.custo_real !== null
                                        ? `€ ${obj_new.custo_real.toFixed(2)}`
                                        : '-'}
                                </div>
                            </div>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-3 gap-x-6 gap-y-5 w-full items-start">
                            <div className="w-full">
                                <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">
                                    Recorrente
                                </div>
                                <div className="text-base font-medium text-gray-800">
                                    {obj_new?.recorrente === true
                                        ? 'Sim'
                                        : obj_new?.recorrente === false
                                            ? 'Não'
                                            : obj_new?.recorrente || '-'}
                                </div>
                            </div>

                            <div className="w-full">
                                <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">
                                    Frequência
                                </div>
                                <div className="text-base font-medium text-gray-800 break-words">
                                    {obj_new?.frequencia || '-'}
                                </div>
                            </div>

                            <div className="w-full">
                                <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">
                                    Condições Meteorologia
                                </div>
                                <div className="text-base font-medium text-gray-800 break-words">
                                    {obj_new?.condicoes_meteo || '-'}
                                </div>
                            </div>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-3 gap-x-6 gap-y-5 w-full items-start">
                            <div className="w-full md:col-span-3">
                                <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">
                                    Notas
                                </div>
                                <div className="text-base font-medium text-gray-800 break-words">
                                    {obj_new?.notas || '-'}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>



        </div>



    </Modal >)

}
